import React from "react"
import { CircularProgress } from "@react-md/progress";

const Spinner = () => (
        <div className="">
            <CircularProgress size="50" className="md-spinner" />
        </div>
)

export default Spinner